import { useState } from 'react'
import { Button } from '@mui/material'

import { MediaAddForm } from '../add-form'

import { useStyles } from './styles'
import { HelperWrapper } from 'src/components/helper-wrapper'

export const AddButton = () => {
  const [open, setOpen] = useState(false)
  const classes = useStyles()

  const handleCreateOpen = () => setOpen(true)
  const handleCreateClose = () => setOpen(false)
  return (
    <>
      <Button variant="contained" className={classes.addButton} onClick={handleCreateOpen}>
        <HelperWrapper t="create-media-button-text" />
      </Button>
      <MediaAddForm open={open} onClose={handleCreateClose} />
    </>
  )
}
